"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * The link wrapper is built to return a Link component and also
 * a useHistory method which can be used to replicate the react-router-dom
 * workflow of changing pages via links or programatically
 */
const LinkWrapper = (Navigate) => ({
    Component: ({ to, className, children }) => {
        const go = (event) => {
            event.preventDefault();
            Navigate(to);
        };
        return (react_1.default.createElement("a", { href: to, onClick: go, className: className }, children));
    },
    useHistory: {
        push: (to) => {
            Navigate(to);
        },
    },
});
exports.default = LinkWrapper;
//# sourceMappingURL=LinkWrapper.js.map